// Dependencies

import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Components

import Header from '../Header/Header';

// Images

import socialNetwork from '../images/social-networking.svg';
import facebookIcon from '../images/facebook.svg';

// Style

import './MenuPreview.css';

class MenuPreview extends React.Component {

  render() {
    return (
      <Link
         className={this.props.isStarter ? "menu-preview_starter-basis" : "menu-preview_specials-basis"}
        to={`/fullmenu#${this.props.foodId}`}>
        <div 
          style={{ 'backgroundImage': `url("${this.props.foodBg}")`,
          'backgroundSize': `${this.props.bGsize}`,
          'backgroundPosition': `${this.props.bGpos}`,
        }}
          className="menu-preview">
          <div className="menu-preview__wrapper">
      
            <Header heading={this.props.foodName} icon={this.props.foodIcon} displayText="none" displayDivider="none" />
          </div>
        </div>
      </Link>
    );
  } 
  }
 

export default MenuPreview;



// WEBPACK FOOTER //
// ./src/MenuPreview/MenuPreview.js